import type { ReactEventHandler } from 'react';

import { icons } from '../Icon';

import PaginationButton from './PaginationButton';
import PaginationControl from './PaginationControl';
import PaginationEllipsis from './PaginationEllipsis';

//  Check if a given page type is an ellipsis
function isEllipsis(pageType: string): boolean {
  return pageType === 'start-ellipsis' || pageType === 'end-ellipsis';
}

//  Map the button types to the icons.
const buttonIconMap = {
  first: icons.stepBackward,
  previous: icons.caretLeft,
  next: icons.caretRight,
  last: icons.stepForward,
};

type PaginationPageProps = {
  page: number;
  type: string;
  isActive: boolean;
  isDisabled: boolean;
  onClick: ReactEventHandler;
};

/**
 * PaginationPage represents an item in the pagination list.
 * Could be an ellipsis, nav button, or actual page number.
 */
const PaginationPage = ({ page, type, isActive, isDisabled, onClick }: PaginationPageProps) => {
  if (isEllipsis(type)) {
    return <PaginationEllipsis />;
  }
  if (type === 'page') {
    return (
      <PaginationButton
        key={page}
        isActive={isActive}
        onClick={onClick}
        isDisabled={isDisabled}
      >
        {page.toLocaleString()}
      </PaginationButton>
    );
  }
  return (
    <PaginationControl
      key={type}
      icon={buttonIconMap[type]}
      onClick={onClick}
      isDisabled={isDisabled}
    />
  );
};

export default PaginationPage;
